import toggle from '@/ui/toggle';

function ShareWidget({ node }) {
	const widget = toggle({
		button: node.querySelector('[data-button]'),
		name: 'share',
		activeClass: 'is-active',
	});
	widget.init();

	widget.on('open:share', () => node.classList.add('is-open'));

	widget.on('close:share', () => node.classList.remove('is-open'));
}

export default ShareWidget;
